module.exports = __webpack_public_path__ + "static/media/filter_black.3e42cc60.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/filter_black.svg
// module id = 869
// module chunks = 0